import {
    getPatternOfFinishingsComponent,
    filterComponentBySheetFinishing,
    getMarcoPassagem,
    setAlizFinishingEqualMarco,
    setPanelFinishingEqualSheet,
} from './proposal-functions.jsx'

const ALIZ_TYPE_FALLBACKS = [
    'component_kit',
    'component_kit_fusion_frame',
    'component_kit_with_band',
    'component_kit_with_band_fusion_frame',
    'component_kit_with_panel',
    'component_kit_with_panel_fusion_frame',
]

const emptyWallPanel = () => ([{
    panel_wall_type: null,
    panel_wall_dimensions: null,
    panel_wall_module: null,
    panel_wall_finishing: null,
    panel_wall_pattern: null,
    panel_wall_instalation: null,
}])

const emptyFixedAlizar = {
    finishing_aliz: null, fixed_aliz: null, fixed_aliz_option_finishing: null, pattern_aliz: null,
    aliz_fixed_section: null, aliz_fixed_section_: null, band_fixed_section: null, panel_fixed_section: null,
}

const emptyAdjustableAlizar = {
    finishing_aliz_adjustable: null, adjustable_aliz: null, adjustable_aliz_option_finishing: null, pattern_aliz_adjustable: null,
    aliz_adjustable_section: null, aliz_adjustable_section_: null, band_adjustable_section: null, panel_adjustable_section: null,
}

const getComponentFinishingId = (component) => (
    component && component.get('finishing') && component.get('finishing').id
)

const findByFinishingAndDimensions = (components, finishingId, { height, width, fill } = {}) => (
    (components || []).find(component => {
        if (!component || !component.get('finishing')) return false
        if (component.get('finishing').id !== finishingId) return false
        if (height != null && (component.get('height_component') || '').toString() !== height.toString()) return false
        if (width != null && (component.get('width_component') || '').toString() !== width.toString()) return false
        if (fill != null && (component.get('fill_componente') || '').toString() !== fill.toString()) return false
        return true
    })
)

const patternStillValid = (componentId, components, finishings, patternId) => {
    if (!patternId || !componentId) return null
    const patterns = getPatternOfFinishingsComponent(componentId, components || [], finishings || [])
    return patterns.some(pattern => pattern.objectId === patternId) ? patternId : null
}

const flattenMatrizComponents = (matriz, fields) => (
    (matriz || [])
        .map(row => fields.map(field => row.get(field) || []).flat())
        .flat()
        .filter(Boolean)
)

const keepIdIfPresent = (componentId, availableComponents) => {
    if (!componentId) return null
    const found = (availableComponents || []).find(component => (
        (component.id || component.objectId || (component.toJSON && component.toJSON().objectId)) === componentId
    ))
    return found ? componentId : null
}

const remapSheet = (product, kitsComponents, finishings) => {
    const finishingId = product.sheet_option_finishing
    const match = finishingId
        ? findByFinishingAndDimensions(kitsComponents.comp_folha, finishingId, {
            height: product.prod_height,
            width: product.prod_width,
        })
        : null

    const finishingSheet = match ? match.id : null
    const patternSheet = patternStillValid(
        finishingSheet,
        kitsComponents.comp_folha,
        finishings,
        product.pattern_sheet,
    )

    const inactiveMatch = finishingSheet
        ? (kitsComponents.comp_folha_inativa || []).find(component => (
            (component.get('height_component') || '').toString() === (product.prod_height || '').toString()
            && getComponentFinishingId(component) === getComponentFinishingId(match)
        ))
        : null

    return {
        finishing_sheet: finishingSheet,
        sheet_option_finishing: match ? finishingId : null,
        pattern_sheet: patternSheet,
        finishing_sheet_inactive: inactiveMatch ? inactiveMatch.id : null,
    }
}

const remapMarco = (product, kitsComponents, finishings, matrizFinishing, marcoThicknessMatriz) => {
    const wallThickness = (marcoThicknessMatriz || []).find(item => item.id === product.wall_thickness)
    const marcoFill = wallThickness ? wallThickness.get('marco_thickness') : null
    const thicknessMatch = marcoFill != null
        ? (kitsComponents.comp_marco || []).find(component => (
            (component.get('fill_componente') || '').toString() === marcoFill.toString()
        ))
        : null

    const thicknessMarco = thicknessMatch ? thicknessMatch.id : null
    const finishingId = product.marco_option_finishing
    const heightMarco = product.prod_height_marco || product.prod_height
    const fillValue = thicknessMatch ? thicknessMatch.get('fill_componente') : null

    const filteredMarco = product.finishing_sheet
        ? filterComponentBySheetFinishing(
            kitsComponents.comp_folha,
            product.finishing_sheet,
            kitsComponents.comp_marco,
            finishings,
            product.marco_material !== 'Madeira' ? [] : (matrizFinishing || []),
        )
        : (kitsComponents.comp_marco || [])

    const marcoMatch = finishingId
        ? findByFinishingAndDimensions(filteredMarco.length ? filteredMarco : kitsComponents.comp_marco, finishingId, {
            height: heightMarco,
            fill: fillValue,
        })
        : null

    const finishingMarco = marcoMatch ? marcoMatch.id : null
    const patternMarco = patternStillValid(finishingMarco, kitsComponents.comp_marco, finishings, product.pattern_marco)

    const passagemFinishingId = product.marco_passagem_option_finishing || finishingId
    const passagemId = getMarcoPassagem(kitsComponents.comp_marco_passagem || [], heightMarco, fillValue)
    const passagemComponent = (kitsComponents.comp_marco_passagem || []).find(component => component.id === passagemId)
    const passagemMatchesFinishing = passagemComponent
        && (!passagemFinishingId || getComponentFinishingId(passagemComponent) === passagemFinishingId)

    return {
        thickness_marco: thicknessMarco,
        finishing_marco: finishingMarco,
        marco_option_finishing: finishingMarco ? finishingId : null,
        pattern_marco: patternMarco,
        finishing_marco_passagem: passagemMatchesFinishing ? passagemId : null,
        marco_passagem_option_finishing: passagemMatchesFinishing ? passagemFinishingId : null,
        pattern_marco_passagem: passagemMatchesFinishing
            ? patternStillValid(
                passagemId,
                kitsComponents.comp_marco_passagem,
                finishings,
                product.pattern_marco_passagem || product.pattern_marco,
            )
            : null,
    }
}

const parseSectionNumber = (section) => (
    parseInt(String(section || '').replace('_fusion-frame', '').replace('x', '').replace('-', ''), 10)
)

const resolveFinishingIdForSection = (product, section) => {
    const isFusion = String(section || '').includes('fusion') || parseSectionNumber(section) >= 100
    if (isFusion) {
        return (product.finishing_sheet && product.sheet_option_finishing) ? product.sheet_option_finishing : null
    }
    return (product.finishing_marco && product.marco_option_finishing) ? product.marco_option_finishing : null
}

const findAlizarIds = ({
    product,
    kitsComponents,
    alizMatriz,
    section,
    alizType,
    isFixed,
    adjustableType,
    newMethodology,
}) => {
    let found = { fixed: null, adjustable: null }
    const sectionValue = String(section || '').replace('_fusion-frame', '')

    setAlizFinishingEqualMarco({
        alizMatriz,
        marcoComponents: kitsComponents.comp_marco,
        marcoId: product.finishing_marco,
        finishingId: resolveFinishingIdForSection(product, section),
        sections: isFixed
            ? { fixed: sectionValue, adjustable: '' }
            : { fixed: '', adjustable: sectionValue },
        panelFlag: product.aliz_options_02,
        updateFunction: (ids) => {
            found = ids || found
        },
        newMethodology,
        adjustableType,
        alizType,
    })

    return found
}

const pickAlizarMatch = ({
    product,
    kitsComponents,
    alizMatriz,
    section,
    preferredType,
    isFixed,
    adjustableType,
    newMethodology,
}) => {
    const typesToTry = preferredType
        ? [preferredType, ...ALIZ_TYPE_FALLBACKS.filter(type => type !== preferredType)]
        : ALIZ_TYPE_FALLBACKS

    for (const alizType of typesToTry) {
        const ids = findAlizarIds({
            product,
            kitsComponents,
            alizMatriz,
            section,
            alizType,
            isFixed,
            adjustableType,
            newMethodology,
        })
        const matched = isFixed ? ids.fixed : ids.adjustable
        if (matched) return { matched, alizType }
    }

    return { matched: null, alizType: preferredType || null }
}

const splitMatchedId = (matched, fallbackFinishingId) => {
    if (!matched) return { id: null, finishingId: null }
    if (String(matched).includes('__')) {
        const [id, finishingId] = String(matched).split('__')
        return { id: id || null, finishingId: finishingId || fallbackFinishingId || null }
    }
    return { id: matched, finishingId: fallbackFinishingId || null }
}

const remapAlizar = (product, kitsComponents, alizMatriz, marcoThicknessMatriz) => {
    if (!product.finishing_marco && !product.marco_option_finishing) {
        return { ...emptyFixedAlizar, ...emptyAdjustableAlizar }
    }

    const wallThickness = (marcoThicknessMatriz || []).find(item => item.id === product.wall_thickness)
    const adjustableType = wallThickness ? wallThickness.get('adjustable_aliz') : null
    const newMethodology = true
    const result = {}

    if (product.aliz_options !== false && product.aliz_fixed_section) {
        const { matched } = pickAlizarMatch({
            product,
            kitsComponents,
            alizMatriz,
            section: product.aliz_fixed_section,
            preferredType: product.aliz_fixed_type,
            isFixed: true,
            adjustableType,
            newMethodology,
        })
        const { id, finishingId } = splitMatchedId(
            matched,
            resolveFinishingIdForSection(product, product.aliz_fixed_section),
        )

        if (id) {
            Object.assign(result, {
                fixed_aliz: id,
                finishing_aliz: id,
                fixed_aliz_option_finishing: finishingId,
                pattern_aliz: product.pattern_aliz || product.pattern_marco,
                aliz_fixed_section: product.aliz_fixed_section,
                aliz_fixed_section_: product.aliz_fixed_section_,
                band_fixed_section: product.band_fixed_section,
                panel_fixed_section: product.panel_fixed_section,
                aliz_fixed_type: product.aliz_fixed_type,
            })
        } else {
            Object.assign(result, emptyFixedAlizar, { aliz_fixed_type: null })
        }
    } else if (product.aliz_options === false) {
        Object.assign(result, emptyFixedAlizar)
    }

    if (product.aliz_options_01 !== false && product.aliz_adjustable_section) {
        const { matched, alizType } = pickAlizarMatch({
            product,
            kitsComponents,
            alizMatriz,
            section: product.aliz_adjustable_section,
            preferredType: product.aliz_adjustable_type,
            isFixed: false,
            adjustableType,
            newMethodology,
        })
        const { id, finishingId } = splitMatchedId(
            matched,
            resolveFinishingIdForSection(product, product.aliz_adjustable_section),
        )

        if (id) {
            Object.assign(result, {
                adjustable_aliz: id,
                finishing_aliz_adjustable: id,
                adjustable_aliz_option_finishing: finishingId,
                pattern_aliz_adjustable: product.pattern_aliz_adjustable || product.pattern_marco,
                aliz_adjustable_section: product.aliz_adjustable_section,
                aliz_adjustable_section_: product.aliz_adjustable_section_,
                band_adjustable_section: product.band_adjustable_section,
                panel_adjustable_section: product.panel_adjustable_section,
                aliz_adjustable_type: alizType || product.aliz_adjustable_type,
            })
        } else {
            Object.assign(result, emptyAdjustableAlizar, { aliz_adjustable_type: null })
        }
    } else if (product.aliz_options_01 === false) {
        Object.assign(result, emptyAdjustableAlizar)
    }

    return result
}

const remapDoorLocksAndHardware = (product, doorLocksMatriz, isCompany) => {
    const kitField = isCompany ? 'component_kit_fechadura' : 'component_kit_fechadura_pf'
    const lockComponents = flattenMatrizComponents(doorLocksMatriz, [
        kitField,
        'component_kit_fechadura',
        'component_kit_macaneta',
    ])
    const ferragemComponents = flattenMatrizComponents(doorLocksMatriz, ['component_kit_ferragens'])

    const conjFechadura = keepIdIfPresent(product.conj_fechadura, lockComponents)
    const hardwareDoorLock = keepIdIfPresent(product.hardware_door_lock, lockComponents)
    const hardwareDoorHandle = keepIdIfPresent(product.hardware_door_handle, lockComponents)

    const hardwareFields = [
        'hardware_puller',
        'hardware_bar_anti_panic',
        'hardware_aerial_spring',
        'hardware_accessories',
        'hardware_accessories_02',
        'hardware_accessories_03',
    ]

    const hardware = {}
    hardwareFields.forEach(field => {
        hardware[field] = keepIdIfPresent(product[field], ferragemComponents)
    })

    const hadLockSelection = !!(product.conj_fechadura || product.hardware_door_lock)
    const locksOk = !hadLockSelection || !!(conjFechadura || hardwareDoorLock)

    return {
        door_lock_composition: locksOk || hardwareDoorHandle ? product.door_lock_composition : null,
        conj_fechadura: conjFechadura,
        hardware_door_lock: hardwareDoorLock,
        hardware_door_handle: hardwareDoorHandle,
        lock_quantity: (conjFechadura || hardwareDoorLock) ? product.lock_quantity : null,
        ...hardware,
        hardware_puller_amount: hardware.hardware_puller ? product.hardware_puller_amount : null,
        hardware_bar_anti_panic_amount: hardware.hardware_bar_anti_panic ? product.hardware_bar_anti_panic_amount : null,
        hardware_aerial_spring_amount: hardware.hardware_aerial_spring ? product.hardware_aerial_spring_amount : null,
        hardware_accessories_amount: hardware.hardware_accessories ? product.hardware_accessories_amount : null,
        hardware_accessories_amount_02: hardware.hardware_accessories_02 ? product.hardware_accessories_amount_02 : null,
        hardware_accessories_amount_03: hardware.hardware_accessories_03 ? product.hardware_accessories_amount_03 : null,
    }
}

const remapWallPanels = (product, kitsComponents, panelsMatriz, finishings) => {
    const panels = product.wall_panel
    if (!panels || !panels.length) return { wall_panel: emptyWallPanel() }

    const remapped = panels.map(panel => {
        let remappedPanel = {
            ...panel,
            panel_wall_module: null,
            panel_wall_finishing: null,
            panel_wall_pattern: null,
        }
        if (!panel.panel_wall_type || !panel.panel_wall_dimensions) return remappedPanel

        setPanelFinishingEqualSheet({
            panelsMatriz,
            wallPanelType: panel.panel_wall_type,
            wallPanelDimensions: panel.panel_wall_dimensions,
            finishings,
            finishingId: product.sheet_option_finishing,
            patternId: product.pattern_sheet,
            sheetComponents: kitsComponents.comp_folha,
            sheetId: product.finishing_sheet,
            updateFunction: ({ finishing, pattern }) => {
                remappedPanel.panel_wall_module = finishing || null
                remappedPanel.panel_wall_finishing = finishing || null
                remappedPanel.panel_wall_pattern = finishing ? (pattern || null) : null
            },
        })
        return remappedPanel
    })

    return { wall_panel: remapped.length ? remapped : emptyWallPanel() }
}

const remapMarcoAddComponents = (product, kitsComponents) => {
    const available = kitsComponents.comp_marco_add || []
    return {
        marco_add_flag_panel: keepIdIfPresent(product.marco_add_flag_panel, available),
        marco_add_flag_panel_glass: keepIdIfPresent(product.marco_add_flag_panel_glass, available),
        marco_add_passage: keepIdIfPresent(product.marco_add_passage, available),
        marco_add_seteira: keepIdIfPresent(product.marco_add_seteira, available),
    }
}

const remapProductComponentsOnKitChange = ({
    product,
    kitsComponents,
    finishings,
    matrizFinishing,
    alizMatriz,
    doorLocksMatriz,
    panelsMatriz,
    marcoThicknessMatriz,
    isCompany,
}) => {
    const sheet = remapSheet(product, kitsComponents, finishings)
    const productWithSheet = { ...product, ...sheet }
    const marco = remapMarco(
        productWithSheet,
        kitsComponents,
        finishings,
        matrizFinishing,
        marcoThicknessMatriz,
    )
    const productWithMarco = { ...productWithSheet, ...marco }
    const alizar = remapAlizar(productWithMarco, kitsComponents, alizMatriz, marcoThicknessMatriz)
    const locksAndHardware = remapDoorLocksAndHardware(product, doorLocksMatriz, isCompany)
    const wallPanels = remapWallPanels(productWithSheet, kitsComponents, panelsMatriz, finishings)
    const marcoAdd = remapMarcoAddComponents(product, kitsComponents)

    return {
        ...product,
        ...sheet,
        ...marco,
        ...alizar,
        ...locksAndHardware,
        ...wallPanels,
        ...marcoAdd,
    }
}

export default remapProductComponentsOnKitChange
